import { Routes } from '@angular/router';
import { Login } from './pages/login/login';
import { UserLayout } from './layout/user-layout/user-layout';
import { AuthGuard, PublicGuard } from '@elan/services/auth.guard';

export const routes: Routes = [
    { path: 'login', component: Login, canActivate: [PublicGuard] },

    {
        path: 'user',
        component: UserLayout,
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('./modules/user/user-module').then(m => m.UserModule),
    },
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: '**', redirectTo: 'login' },
];
